import { render, staticRenderFns } from "./PdpLocallyProductFinder.vue?vue&type=template&id=4f6b44c1&"
import script from "./PdpLocallyProductFinder.vue?vue&type=script&lang=js&"
export * from "./PdpLocallyProductFinder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports